"use strict";

exports.__esModule = true;
exports.formatLabel = formatLabel;
const labels = {
  "ga:page": "Side",
  "ga:pageviews": "Sidevisninger",
  "ga:uniquePageviews": "Unike sidevisninger",
  "ga:users": "Brukere",
  "ga:bounceRate": "Fluktfrekvens",
  "ga:avgTimeOnPage": "Gj. tid brukt"
};

function formatLabel(label, language = "nb") {
  if (labels[label]) {
    return labels[label];
  }

  return label;
}